@if (isLoading) {
  <mat-progress-bar class="tpa-spinner" mode="query" color="primary"></mat-progress-bar>
}
<div class="tpa-search">
  <div class="tpa-search__header">
    <div class="tpa-search__header-title  tpa-search__tile">
      <div>You can search a member based on 2 of 3 inputs, for example:</div>
      <ul>
        <li>First Name, Last Name AND Date of Birth</li>
        <li>First Name, Last Name AND Member ID/Policy Number/Alternative ID</li>
        <li>Date Of Birth AND Member ID/Policy Number/Alternative ID</li>
      </ul>
    </div>
    <div class="tpa-search__header-last-searches tpa-search__tile">
      <mat-form-field appearance="outline" class="tpa-search__header-last-searches__dropdown">
        <mat-label>Recent Searches</mat-label>
        <mat-select [(value)]="selectedSearch" (selectionChange)="onSearchSelect($event.value)"
                    [disabled]="!lastSearches || !lastSearches.length">
          @for (search of lastSearches; track trackBySearch($index, search)) {
            <mat-option [value]="search">
              {{ search | searchDisplay }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button
              color="primary"
              class="clear-button"
              (click)="clearForm()"
              matTooltip="Clear selection"
              [disabled]="!selectedSearch">
        Clear
      </button>
    </div>
  </div>


  <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
    <div class="tpa-search__form  tpa-search__tile">
      <div class="tpa-search__column">

        <mat-form-field appearance="outline">
          <mat-label>First Name</mat-label>

          <input matInput formControlName="firstName">
        </mat-form-field>


        <mat-form-field appearance="outline">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName">
        </mat-form-field>
      </div>

      <div class="tpa-search__separator"></div>

      <div class="tpa-search__column">
        <mat-form-field appearance="outline">
          <mat-label>Date of Birth</mat-label>
          <mat-hint><i><small>yyyy-mm-dd</small></i></mat-hint>
          <input matInput [matDatepicker]="picker" formControlName="dateOfBirth">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="tpa-search__separator"></div>

      <div class="tpa-search__column">
        <mat-form-field appearance="outline">
          <mat-label>Member ID</mat-label>
          <input matInput formControlName="memberId">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Alternative ID</mat-label>
          <input matInput formControlName="externalId">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Policy Number</mat-label>
          <input matInput formControlName="policyNumber">
        </mat-form-field>
      </div>
    </div>


    <div class="tpa-search__error">
      <ul>
        @for (error of errorMessages; track $index) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>

    <div class="tpa-search__button">
      <button mat-raised-button color="primary" type="submit">Search</button>
    </div>
  </form>


</div>
